import { render, staticRenderFns } from "./ColorSelector.vue?vue&type=template&id=1be38cd2&scoped=true"
import script from "./ColorSelector.vue?vue&type=script&lang=js"
export * from "./ColorSelector.vue?vue&type=script&lang=js"
import style0 from "./ColorSelector.vue?vue&type=style&index=0&id=1be38cd2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be38cd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\ideaWorkSpace\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1be38cd2')) {
      api.createRecord('1be38cd2', component.options)
    } else {
      api.reload('1be38cd2', component.options)
    }
    module.hot.accept("./ColorSelector.vue?vue&type=template&id=1be38cd2&scoped=true", function () {
      api.rerender('1be38cd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chart/components/shapeAttr/ColorSelector.vue"
export default component.exports